const state = {
  techProvidersFilters: null,
  requestRFPFilters: {
    keyword_search: null,
    newcategory: [],
    newcategory_names: [],
    marketapplication: [],
    marketapplication_names: [],
    address: null,
    responsible_company: false,
    size: null,
    founded_min: null,
    founded_max: null
  },
  filteredTechProviders: null
}

const mutations = {
  SET_TECH_PROVIDERS_FILTERS (state, payload) {
    state.techProvidersFilters = payload
  },
  SET_REQUEST_RFP_FILTERS (state, payload) {
    state.requestRFPFilters = payload
  },
  SET_FILTERED_TECH_PROVIDERS (state, payload) {
    state.filteredTechProviders = payload
  }
}

const actions = {
  setTechProvidersFilters ({ commit }, payload) {
    commit('SET_TECH_PROVIDERS_FILTERS', payload)
  },
  setRequestRfpFilters ({ commit }, payload) {
    commit('SET_REQUEST_RFP_FILTERS', payload)
  },
  setFilteredTechProviders ({ commit }, payload) {
    commit('SET_FILTERED_TECH_PROVIDERS', payload)
  }
}

const getters = {
  getTechProvidersFilters (state) {
    return state.techProvidersFilters
  },
  getRequestRfpFilters (state) {
    return state.requestRFPFilters
  },
  getFilteredTechProviders (state) {
    return state.filteredTechProviders
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
